/* eslint-disable camelcase */

import PropTypes from 'prop-types'
import { useCallback, useEffect } from 'react'
import { connect } from 'react-redux'
import Actions from '../../../actions'
import { useCarePlanPopulated } from '../../../shared/hooks/useCarePlanPopulated'
import { history } from '../../../store'
import { withRouter } from '../../../withRouter'
import CarePlanForm from '../components/CarePlanReviewForm'

/**
 * Fetch the data required and initialise the form state to render the CarePlanReviewForm
 */
export const CarePlanReviewScreen = ({
  addForm,
  editCarePlanFormExists,
  removeForm,
  router
}) => {
  const {
    params: { care_plan_id }
  } = router

  const { data: careplan, isLoading } = useCarePlanPopulated({
    carePlanId: care_plan_id
  })

  const addFormWithReset = useCallback(
    (plan) => {
      const planCopy = { ...plan }
      if (planCopy.nextReviewDate) planCopy.nextReviewDate = null
      addForm(planCopy)
    },
    [addForm]
  )

  // Add form when careplan becomes available and form doesn't exist
  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (!editCarePlanFormExists && careplan) {
      addFormWithReset(careplan)
    }
  }, [careplan, editCarePlanFormExists, addFormWithReset])

  // Clean up form when unmounting to ensure fresh data on next visit
  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    return () => {
      removeForm()
    }
  }, [removeForm])

  if (isLoading || !careplan) return null

  return (
    <CarePlanForm
      router={history}
      params={router.params}
      carePlanLogs={careplan.logs}
    />
  )
}

CarePlanReviewScreen.propTypes = {
  addForm: PropTypes.func.isRequired,
  editCarePlanFormExists: PropTypes.bool,
  removeForm: PropTypes.func.isRequired,
  router: PropTypes.object
}

const mapStateToProps = (state) => ({
  editCarePlanFormExists: !!state.forms.editCarePlan
})

const mapDispatchToProps = (dispatch) => ({
  addForm: (initial) =>
    dispatch(
      Actions.addForm({
        formId: 'editCarePlan',
        initial
      })
    ),
  removeForm: () => dispatch(Actions.removeForm('editCarePlan'))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CarePlanReviewScreen))
